module.exports = __webpack_public_path__ + "img/check.2add146a.svg";